import { SET_GALLERY } from "../actionTypes"

const initialState = {
  galleryObject: {},
  gallery: [],
}

const galleryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GALLERY:
      return {
        ...state,
        gallery: action.gallery.data,
        galleryObject: action.gallery
      }
    default:
      return state
  }
}

export default galleryReducer